(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const instances = new Map();

  function initialize(scope = document) {
    const footers = Array.from(scope.querySelectorAll('.site-footer'));
    if (scope.matches?.('.site-footer')) footers.unshift(scope);
    footers.forEach(footer => {
      if (instances.has(footer)) return;
      const groups = Array.from(footer.querySelectorAll('[data-footer-menu]'));
      const abort = new AbortController();
      const signal = abort.signal;
      const setMode = () => groups.forEach(group => {
        const summary = group.querySelector('summary');
        group.open = !mobile.matches;
        if (mobile.matches) {
          summary.removeAttribute('tabindex');
          summary.removeAttribute('aria-disabled');
        } else {
          summary.tabIndex = -1;
          summary.setAttribute('aria-disabled', 'true');
        }
      });
      groups.forEach(group => {
        group.querySelector('summary').addEventListener('click', event => {
          if (!mobile.matches) event.preventDefault();
          else if (!group.open) groups.forEach(other => {
            if (other !== group) other.open = false;
          });
        }, { signal });
      });
      mobile.addEventListener('change', setMode, { signal });
      setMode();
      instances.set(footer, abort);
    });
  }

  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((abort, footer) => {
      if (event.target.contains(footer)) {
        abort.abort();
        instances.delete(footer);
      }
    });
  });
})();
